import { toCreateContactInput } from './create-mapper.js';
/** The contact rows to send with a new customer or vendor; none sends no `contacts` at all. */
export function toNewContactsInput(contacts) {
    return contacts.length > 0 ? contacts.map(toCreateContactInput) : undefined;
}
//# sourceMappingURL=to-new-contacts-input.js.map